import { useEffect, useState } from "react";
import { fmtFull } from "../../shared/format.js";
import { CaptureView } from "./CaptureView.js";
import type { GuestEvent, GuestIdentity } from "./guest.api.js";

export function CaptureTab({
  data,
  token,
  identity,
  identityValid,
  onNeedIdentity,
}: {
  data: GuestEvent;
  token: string | undefined;
  identity: GuestIdentity;
  identityValid: boolean;
  onNeedIdentity: () => void;
}) {
  const { captureState, captureStartAt, captureEndAt } = data.event;

  if (!identityValid) {
    return (
      <Center>
        <p style={{ color: "var(--theme-muted)" }}>
          Renseignez votre nom et votre email pour commencer.
        </p>
        <button
          onClick={onNeedIdentity}
          className="mt-4 rounded-full px-6 py-3 text-sm font-semibold"
          style={{ background: "var(--theme-primary)", color: "var(--theme-primary-text)" }}
        >
          C'est parti
        </button>
      </Center>
    );
  }

  if (captureState === "before") {
    return (
      <Center>
        <span className="text-4xl">⏳</span>
        <p className="mt-3 font-serif text-lg" style={{ color: "var(--theme-text)" }}>
          Bientôt à vous de jouer
        </p>
        <p className="mt-1 text-sm" style={{ color: "var(--theme-muted)" }}>
          Les contributions ouvrent {captureStartAt && fmtFull(captureStartAt)}.
        </p>
        {captureStartAt && <Countdown target={captureStartAt} />}
      </Center>
    );
  }

  if (captureState === "closed") {
    return (
      <Center>
        <span className="text-4xl">🌙</span>
        <p className="mt-3 font-serif text-lg" style={{ color: "var(--theme-text)" }}>
          Les contributions sont closes
        </p>
        <p className="mt-1 text-sm" style={{ color: "var(--theme-muted)" }}>
          Merci ! Fermées {captureEndAt && fmtFull(captureEndAt)}. Rendez-vous dans l'onglet
          Galerie.
        </p>
      </Center>
    );
  }

  return (
    <CaptureView
      eventId={data.event.id}
      token={token}
      identity={identity}
      onSent={() => undefined}
    />
  );
}

function Countdown({ target }: { target: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);
  let ms = new Date(target).getTime() - now;
  if (ms < 0) ms = 0;
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  const parts = d > 0 ? [`${d} j`, `${h} h`, `${m} min`] : [`${h} h`, `${m} min`, `${s} s`];
  return (
    <p className="mt-4 font-mono text-lg tracking-wider" style={{ color: "var(--theme-primary)" }}>
      {parts.join("  ")}
    </p>
  );
}

function Center({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-full flex-col items-center justify-center px-8 text-center">
      {children}
    </div>
  );
}
